import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../environments/environment";
import {NotificationHistory} from "../interface/notification-history";
import {Message} from "../interface/message";

@Injectable({
  providedIn: 'root'
})
export class NotificationHistoryService {

  private baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }
  get(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/notification/history/${id}`);
  }
  getCollection(): Observable<NotificationHistory[]>{
    return this.http.get<NotificationHistory[]>(`${this.baseUrl}/get/notification/histories`);
  }

  getCountedNotification(): Observable<NotificationHistory[]>{
    return this.http.get<NotificationHistory[]>(`${this.baseUrl}/get/count/notification/histories`);
  }
  read(data: any): Observable<any>{
    return this.http.post<any>(`${this.baseUrl}/read/notifications`, data);
  }
  deleteMultiple(ids: number[]): Observable<NotificationHistory[]>{
    const options = {body: ids};
    return this.http.delete<NotificationHistory[]>(`${this.baseUrl}/delete/selected/notification/histories`, options);
  }

}
